var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListagem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "22px",
    viewBox: "0 0 28 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "listagem") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-1394.000000, -38.000000)",
    fillRule: "nonzero",
    stroke: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(1384.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "listagem",
    transform: "translate(12.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 0,
    x2: 24,
    y2: 0,
    id: "Vector",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 24,
    y2: 9,
    id: "Vector",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 18,
    x2: 24,
    y2: 18,
    id: "Vector",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "Vector",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 9,
    x2: 1,
    y2: 9,
    id: "Vector",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 18,
    x2: 1,
    y2: 18,
    id: "Vector",
    strokeWidth: 3.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListagem);
export default __webpack_public_path__ + "static/media/listagem.a982466d65a854f859200e2d622f0a87.svg";
export { ForwardRef as ReactComponent };